// extracted by mini-css-extract-plugin
export default {"customerCont":"Customer_customerCont__1vA0q","customer":"Customer_customer__QqcJA","customerLogo":"Customer_customerLogo__Qdmbx"};